import { listViewStore, TableQueryType } from 'owa-mail-list-store';
import type { SearchTableQuery } from 'owa-mail-list-search';
import { PeopleSuggestion, SuggestionKind } from 'owa-search-service/lib/data/schema/SuggestionSet';

export function getPersonaSuggestionPillHeaderData(
    tableViewId: string | undefined
): PeopleSuggestion[] {
    if (tableViewId) {
        const tableView = listViewStore.tableViews.get(tableViewId);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (13,13): Object is possibly 'undefined'.
        // @ts-expect-error
        if (tableView.tableQuery.type != TableQueryType.Search) {
            throw new Error(
                'getPersonaSuggestionPillHeaderData should not be called for non-search scenario'
            );
        }

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (22,34): Object is possibly 'undefined'.
        // @ts-expect-error
        const searchTableQuery = tableView.tableQuery as SearchTableQuery;
        const personaSuggestions = searchTableQuery.pillSuggestions.filter(suggestion => {
            return suggestion.kind == SuggestionKind.People;
        });

        // Fow now, we only handle the case where all search suggestion pills are of type persona.
        if (searchTableQuery.pillSuggestions.length === personaSuggestions.length) {
            return personaSuggestions as PeopleSuggestion[];
        }
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (36,5): Type 'null' is not assignable to type 'PeopleSuggestion[]'.
    // @ts-expect-error
    return null;
}
